import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  @Input()
  notification:any;
  purpose:string;
  constructor() { 
  }

  ngOnInit() {
    this.purposeCreation();
  }
  /**
   * Purpose Text of notification elements is being created with the help of status and other details.
   */
  purposeCreation(){
    if(this.notification['transactionID']==null){
      this.notification['transactionID']='123123'
    }
    if(this.notification['eventType']=="CONSENT_CREATED"){
      this.purpose="Consent has been created with transaction ID "+this.notification['transactionID']; 
    }else if(this.notification['eventType']=="CONSENT_REQUEST"){
      this.purpose="Consent Request from "+this.notification['from']+" with transaction ID "+this.notification['transactionID'];
    }else{
      this.purpose="Consent Request from "+this.notification['from']+" with transaction ID "+this.notification['transactionID'];
    }
  }
}
